interface ScoreTableProps {
  categories: {
    id: number;
    content: string;
    score: number | null;
  }[];
  score: number | null;
}

function ScoreTable({ categories, score }: ScoreTableProps) {
  return (
    <div className="rounded-lg border">
      <table className="w-full divide-y rounded-lg">
        <tbody>
          {categories.map((category) => (
            <tr
              key={category.id}
              className="border-b border-cool-gray-300 last:border-none"
            >
              <td className="px-6 py-4">{category.content}</td>
              <td className="px-6 py-4 text-end">
                <span className="text-lg font-medium text-cool-gray-900">
                  {category.score ?? "--"}{" "}
                </span>
                {category.score && <span>/100</span>}
              </td>
            </tr>
          ))}
          <tr>
            <td className="px-6 py-4">合計</td>
            <td className="px-6 py-4 text-end">
              <span className="text-lg font-medium text-cool-gray-900">
                {score ?? "--"}{" "}
              </span>
              {score && <span>/{categories.length * 100}</span>}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default ScoreTable;
